import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer
} from '@mui/material'
import styled from 'styled-components'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

const TableContainerStyled = styled(TableContainer)`
  margin-top: ${SPACING.spacing15};
`
const TableStyled = styled(Table)``

export interface ITableHead {
  backgroundColor?: string
  textColor?: string
}
const TableHeadStyled = styled(TableHead)<ITableHead>`
  tr {
    box-shadow: inset 0px -1px 0px rgba(102, 102, 102, 0.08);
    background: ${({ backgroundColor }) =>
      backgroundColor || COLORS.tableColor};
  }
  th {
    padding: 0 4px 0 4px;
    margin: 0;
    height: 36px;
    color: ${({ textColor }) => textColor || COLORS.blueFonts};
    font-size: ${TYPOGRAPHY.bodySize14};
    font-weight: ${FONTS.bold};
    font-family: Arial;

    :first-child {
      border-radius: 2px 0 0 0;
    }
    :last-child {
      border-radius: 0 2px 0 0;
    }
  }
`
const TableBodyStyled = styled(TableBody)`
  td {
    padding: 0 4px 0 4px;
    margin: 0;
    height: 36px;
    color: ${COLORS.black};
    font-family: Arial;
    font-size: ${TYPOGRAPHY.bodySize13};
    font-weight: ${FONTS.bold};
  }
`
interface ITableRow {
  backgroundColor?: string
}

const TableRowStyled = styled(TableRow)<ITableRow>`
  background: ${({ backgroundColor }) => backgroundColor || COLORS.transparent};
`

interface ITableCell {
  minwidth?: string
  maxwidth?: string
}

const TableCellStyled = styled(TableCell)<ITableCell>`
  && {
    min-width: ${({ minwidth }) => minwidth};
    max-width: ${({ maxwidth }) => maxwidth};
    cursor: pointer;
  }
`

export {
  TableCellStyled,
  TableRowStyled,
  TableBodyStyled,
  TableStyled,
  TableHeadStyled,
  TableContainerStyled
}
